/**
 * Webカメラを初期化し、映像ストリームを開始する
 * @param video HTMLVideoElement
 * @returns MediaStream
 */
export const startWebcam = async (video: HTMLVideoElement): Promise<HTMLVideoElement> => {
  const constraints = {
    video: {
      width: { ideal: 1280 },
      height: { ideal: 720 },
      aspectRatio: 16 / 9,
      facingMode: 'user'
    }
  };

  try {
    const stream = await navigator.mediaDevices.getUserMedia(constraints);
    video.srcObject = stream;
    await new Promise((resolve) => {
      video.addEventListener('loadeddata', resolve, { once: true });
    });
    return video;
  } catch (error) {
    console.error('Error accessing webcam:', error);
    throw error;
  }
}